
import ArrowLeft2 from "../../../assets/outline/ArrowLeft2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowLeft2Icon({ className, dataTestid = "ArrowLeft2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowLeft2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
